import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { useDispatch } from 'react-redux';
import { updatePersonalForm } from '../../core/actions';
import './opening-questions.scss';

const OpeningQuestions: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [formData, setFormData] = React.useState<any>({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
    });

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                return;
            }
        } else if (name === 'firstName') {
            if (value.length < 3) {
                return;
            }
        } else if (name === 'lastName') {
            if (value.length < 3) {
                return;
            }
        } else if (name === 'phone') {
            if (value.length < 5) {
                return;
            }
        }
        setFormData((prevState: any) => ({ ...prevState, [name]: value }));
    };

    function onSubmitted() {
        dispatch(updatePersonalForm('first_name', formData.firstName));
        dispatch(updatePersonalForm('last_name', formData.lastName));
        dispatch(updatePersonalForm('phone', formData.phone));
        dispatch(updatePersonalForm('email', formData.email));
        navigate('/patient-age-range', { replace: true });
    }
    return (
        <div className="opening-questions">
            <h1 className="opening-questions__title">First, please tell us a little about yourself.</h1>
            <h4 className="opening-questions__subtitle">Begin your journey with us by sharing a glimpse of your story. Rest assured, your privacy is our priority, and this information will be held in strict confidence to tailor our care to your unique needs.</h4>
            <Input name={'firstName'} label={'First Name'} required={true} placeholder='Jane' onChanged={handleChange} />
            <Input name={'lastName'} label={'Last Name'} required={true} placeholder='Smith' onChanged={handleChange} />
            <Input name={'phone'} type='number' label={'Phone Number'} required={true} placeholder='(201) 555-0123' onChanged={handleChange} />
            <Input name={'email'} type='email' label={'Email'} required={true} placeholder='name@example.com' onChanged={handleChange} />
            <Button type='primary' onPressed={onSubmitted} disabled={Object.values(formData).some(value => !value)}>
                {'Next'}
            </Button>
        </div>
    );
}

export default OpeningQuestions;
